import { Typography } from "antd";
import { type LinkProps as AntdLinkProps } from "antd/lib/typography/Link";

import type { AvE2EProps } from "@av/components/types";

type LinkProps = AntdLinkProps & AvE2EProps;

export function CustomLink(props: LinkProps) {
  const { testIdPrefix, ...rest } = props;

  return <Typography.Link data-testid={testIdPrefix + "-link"} {...rest} />;
}
